module.exports = __webpack_public_path__ + "static/google-play-71c2bd9d7542d3d2fe8ce113c74011bb.png";